<template>
  <widget-template :scroll="false">
    <v-layout row wrap class="smallWidgetLayout" fill-height>
      <v-flex xs4 align-center justify-center d-flex>
        <v-icon color="blue" class="widgetIcon">mdi-account-multiple</v-icon>
      </v-flex>
      <v-flex xs8 d-flex>
        <v-layout column justify-end>
          <v-flex class="widgetHeader ma-2" d-flex justify-end>Users Online</v-flex>
            <v-flex :class="[widgetTextStyle(usersOnline.usersOnline), 'ma-2']" d-flex justify-end>
              <span style="color: teal;">{{ animatedNumber }}</span>
            </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="widgetInfoPnl">
        <v-divider></v-divider>
        <v-layout row wrap class="widgetInfo grey--text ml-2 mt-1" align-center justify-center>
            <v-layout align-center class="widgetAction" @click="$router.push({ name: 'usersSessions' })">
              <div class="d-flex align-center">
                <v-icon class="details_icon">mdi-eye</v-icon>
                <span>Click to view users</span>
              </div>
            </v-layout>
          <v-spacer></v-spacer>
          <div v-if="initState === 0">
            <!-- <v-tooltip top>
              <span v-on="on">
                <v-icon small color="orange">mdi-record</v-icon>
                Loading...
              </span>
              <span>Loading</span>
            </v-tooltip> -->
          </div>
          <div v-else-if="initState === 1">
            <!-- <v-tooltip top>
              <div v-on="on" @click="doReload" class="widgetAction">
                Updated {{lastUpdated}} ago
              </div>
              <span>Click to update</span>
            </v-tooltip> -->
          </div>
          <div v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on" @click="doReload" class="widgetAction">
                  <v-icon small color="red">mdi-record</v-icon>
                  Error
                </div>
                <span>Click to retry</span>
              </template>
            </v-tooltip>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { widgetMixin } from '../widgetMixin'
import { TweenLite } from 'gsap/TweenMax'

export default {
  data() {
    return {
      tweenedNumber: 0
    }
  },
  watch: {
    'usersOnline.usersOnline': function (newValue) {
      this.doAnimateNumber(newValue)
    }
  },
  computed: {
    usersOnline() {
      return this.$store.state.widgets.usersOnline
    },
    initState() {
      return this.usersOnline.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.usersOnline.lastUpdated, this.timeNow)
    },
    animatedNumber() {
      return this.tweenedNumber.toFixed(0)
    }
  },
  methods: {
    ...mapActions(['initUsersOnline']),
    doReload() {
      this.initUsersOnline()
    },
    doAnimateNumber(newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedNumber: newValue })
    }
  },
  mounted() {
    this.doAnimateNumber(this.usersOnline.usersOnline)
    this.doReload()
  },
  mixins: [widgetMixin(true)]
}
</script>

<style lang="scss" scoped>
.details_icon {
  margin-right: 8px;
}
</style>
